import { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";

function MarkdownPage({ filename }: { filename: string }) {
  const [markdownContent, setMarkdownContent] = useState("");

  useEffect(() => {
    fetch(`/data/projects/${filename}/2025-03-21.md`)
      .then((response) => response.text())
      .then((text) => setMarkdownContent(text));
  }, [filename]);

  return (
    <div className="prose max-w-none">
      <ReactMarkdown
        children={markdownContent}
        remarkPlugins={[remarkGfm]}
        rehypePlugins={[rehypeRaw]}
      />
    </div>
  );
}

export default MarkdownPage;
